import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, catchError, map, of, switchMap } from 'rxjs';

import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { AuthFacadeService } from 'src/app/services/auth/auth-facade.service';
import { Roles } from 'src/app/shared/models';
import { Routes } from 'src/app/shared/routes/routes';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  getAddedTodayProperties,
  getAddedTodayPropertiesFailure,
  getAddedTodayPropertiesSuccess,
  getArisPrimeProperties,
  getArisPrimePropertiesFailure,
  getArisPrimePropertiesSuccess,
  getRecommendedProperties,
  getRecommendedPropertiesFailure,
  getRecommendedPropertiesSuccess,
} from './actions';
import { SharedService } from 'src/app/services/shared/shared.service';
@Injectable()
export class SharedStoreEffects {
  roles = Roles;
  routes = Routes;
  modalService = inject(NgbModal);
  sharedService = inject(SharedService);
  constructor(
    private actions$: Actions,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private authFacade: AuthFacadeService
  ) {}

  getAddedTodayPropertiesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getAddedTodayProperties),
      switchMap(() =>
        this.sharedService.getAddedTodayProperties().pipe(
          map((res) => getAddedTodayPropertiesSuccess({ data: res })),
          catchError((error) => {
            return of(getAddedTodayPropertiesFailure({ error }));
          })
        )
      )
    );
  });

  getArisPrimePropertiesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getArisPrimeProperties),
      switchMap(() =>
        this.sharedService.getArisPrimeProperties().pipe(
          map((res) => getArisPrimePropertiesSuccess({ data: res })),
          catchError((error) => {
            return of(getArisPrimePropertiesFailure({ error }));
          })
        )
      )
    );
  });

  getRecommendedPropertiesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getRecommendedProperties),
      switchMap(() =>
        this.sharedService.getRecommendedProperties().pipe(
          map((res) => getRecommendedPropertiesSuccess({ data: res })),
          catchError((error) => {
            return of(getRecommendedPropertiesFailure({ error }));
          })
        )
      )
    );
  });
}
